import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return (
    <div className="min-h-screen bg-white flex items-center justify-center" data-testid="loading-screen">
      <Loader2 className="w-7 h-7 animate-spin text-[#EF4444]" />
    </div>
  );
  if (!user) return <Navigate to="/auth" replace />;
  // June 2026 auth restriction: legacy email-only users must link a
  // Google/Phone/Apple account before accessing the app.
  if (user.must_link_provider && location.pathname !== '/link-account') {
    return <Navigate to="/link-account" replace />;
  }
  return children;
}
